import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
    AllCharities,
    CharityPartners,
    CancelledShopPartnerships,
    PendingShopRequests,
    RefusedShopRequests,
    Error404,
} from '../domains';

const ShopPartnershipsRoutes = () => {
    return (
        <Switch>
            <Route exact path="/partnerships" component={CharityPartners} />
            <Route
                exact
                path="/partnerships/all-charities"
                component={AllCharities}
            />
            <Route
                exact
                path="/partnerships/cancelled-partnerships"
                component={CancelledShopPartnerships}
            />
            <Route
                exact
                path="/partnerships/pending-requests"
                component={PendingShopRequests}
            />
            <Route
                exact
                path="/partnerships/refused-requests"
                component={RefusedShopRequests}
            />
            <Route component={Error404} />
        </Switch>
    );
};

export default ShopPartnershipsRoutes;
